<template>
  <div :class="['scenario_option', {tree: options.length !== 4}]">
    <ul>
      <li v-for="option in options">
        <div
            @click="option.selected = !option.selected;selectMany()"
            :class="['option_wrap', {active: option.selected}]">
          <div class="option_img">
            <img :src="option.asset_image" alt="">
          </div>
          <div class="option_text" v-html="option.label"></div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {dispatch} from "vuex-pathify";


export default {
  name: "multiple_choice_image",
  props: {
    options: Array,
    page_no: Number
  },
  methods: {
    selectMany() {
      let selectedArr = []
      this.options.forEach(item => {
        if (item.selected) selectedArr.push(item)
      })
      let moduleName = store.get('moduleName')
      dispatch(`${moduleName}/setPostData`, {page_no: this.page_no, page_answer: selectedArr})
    }
  },
  created() {
    this.selectMany()
  }
}
</script>

<style scoped>

</style>